import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { BsPencil } from 'react-icons/bs'

import Nav from '../../../components/Nav'
import ActionButton from '../../../components/ActionButton';
import InventoryMenu from '../../../components/inventory/InventoryMenu';

function SupplierList(props) {
    const pencilIcon = <BsPencil size="14"/>
    const [suppliers, setSuppliers] = useState({status: 0, v:[], error:null})

    useEffect(() => {
        const onListResponse = (data, error) => {
            if (error) {
                setSuppliers({status: 1, v:[], error: error})
            } else {
                setSuppliers({status: 1, v:data.suppliers ? data.suppliers : [], error: null})
            }
        }
        props.backend.SupplierList(onListResponse)
    }, [props.backend])
    
    return (
        <>
        <Nav isMain={false} subtitle="Inventory" {...props} />
        <InventoryMenu {...props} section="suppliers" />
        <div className="filterMenu">
            <Link to="/inventory/suppliers/new">
                <ActionButton T={props.T} title="New" icon={pencilIcon} />
            </Link>
        </div>
        {suppliers.status === 0 && <div className="loadingOverlay"></div>}
        {suppliers.status === 1 && 
            <div className="content">
                <p className="contentSubtitle">{props.T("SuppliersList")}</p><br />
                <div className="hscrollcontainer">
                <table id="supplierList">
                    <thead>
                    <tr>
                        <td align="center" >{props.T("Name")}</td>
                        <td align="center" >&nbsp;</td>
                    </tr>
                    </thead>
                    <tbody>
                    {suppliers.v.length === 0 &&
                        <tr><td colSpan="4">{props.T("NoSuppliersFound")}</td></tr>
                    }
                    {suppliers.v.length > 0 &&
                        suppliers.v.map(s => {return (
                            <tr key={s.id}>
                            <td align="Left">{s.name}</td>
                            <td align="center">
                                <Link to={"/inventory/suppliers/edit/"+s.id}>
                                    <ActionButton T={props.T} title="Edit" icon={pencilIcon} />
                                </Link>
                            </td>
                            </tr>
                        )})
                    }
                    </tbody>
                </table>
                </div>
            </div>
            }
        </>
    )
}

export default SupplierList
